import { composeWithDevTools } from '@redux-devtools/extension';
import { legacy_createStore as createStore } from 'redux';

import * as Actions from './actions';
import initialState from './initialState';
import reducer from './reducer';
import selectors from './selectors';

const store = createStore(reducer, initialState, composeWithDevTools());
const Store: {
  store: any;
  Actions: typeof Actions;
  Selectors: typeof selectors;
} = { store, Actions, Selectors: selectors };
export default Store;
